// ======================================================================
// File Name       : TableHead.js
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { ASCENDING_DESCENDING_SORT } from '../constants/index';
/**
 * Create thead and sort function
 */
class TableCell extends React.Component {
  constructor() {
    super();
    this.state = {
      sortState: ASCENDING_DESCENDING_SORT.DESCENDING,
    };
  }
  sortData(item) {
    item.sortState =
      this.props.cell.sortState === ASCENDING_DESCENDING_SORT.DESCENDING
        ? ASCENDING_DESCENDING_SORT.ASCENDING
        : ASCENDING_DESCENDING_SORT.DESCENDING;
    this.props.handleUpdateSortState(item);
  }

  shouldComponentUpdate(nextProps, nextState) {
    this.state.sortState = nextProps.cell.sortState;
    return true;
  }
  render() {
    let sortIcon;
    if (this.props.cell.sortState === ASCENDING_DESCENDING_SORT.ASCENDING) {
      sortIcon = (
        <span className="sort-icon">
          <i role="button" className="bi bi-caret-up-fill" />
        </span>
      );
    }
    if (this.props.cell.sortState === ASCENDING_DESCENDING_SORT.DESCENDING) {
      sortIcon = (
        <span className="sort-icon">
          <i role="button" className="bi bi-caret-down-fill" />
        </span>
      );
    }

    if (!this.props.cell.isSort) {
      sortIcon = (
        <span className="sort-icon">
          <i role="button" className="bi bi-caret-up-fill" />
          <i role="button" className="bi bi-caret-down-fill" />
        </span>
      );
    }
    return (
      <th
        onClick={this.props.cell.sortBy !== null ? this.sortData.bind(this, this.props.cell) : null}
        width={this.props.width}
      >
        <span className="sort-title">
          {this.props.cell.title}
        </span>
        {this.props.cell.sortBy !== null ? sortIcon : null}
      </th>
    );
  }
}

export default TableCell;
